// START Open Requre.JS wrapper
define([
	"jquery",
	"domReady",
	'shared.main.screen',
	"pubsub"
], function( $, domReady, screenSize ){
    	
    	var DEBUG = false;

    	var ProductFormUtilities = function () {
    		if (!(this instanceof ProductFormUtilities)) {
				return new ProductFormUtilities();
			}
    	};

    	ProductFormUtilities.prototype = {

    		init : function () {

    			if ( DEBUG ) console.log('ProductFormUtilities.prototype.init');

    			var self = this;

    			self._initPubSubEvents();

    			return self;

    		},

    		_initPubSubEvents : function () {

    			if ( DEBUG ) console.log('ProductFormUtilities.prototype._initPubSubEvents');

    			var self = this;

				$.pubsub('subscribe', 'product-form.attr.swatch.click', function(msg, event){
					var $quickViews = $('.quickview-modal.open').length;

					//only scroll to top if there isn't a modal opened
					if($quickViews < 1) self.mobileScrollToTopViewAfterSwatchSelection(event);
				});

    		},

    		convert : function (convert) {

    			if ( DEBUG ) console.log('ProductFormUtilities.prototype.convert');

    			return $("<span />", { html: convert }).text();
    		},

    		getScrollbarSize : function () {

    			if ( DEBUG ) console.log('ProductFormUtilities.prototype.getScrollbarSize');

				var dummyDiv = $('<div style="width: 50px; height: 50px; overflow: auto; position: absolute; top: -200px; left: -200px;"><div></div></div>').appendTo('body');
				var dummyDivChild = dummyDiv.children().first();
				_scrollbarSize = $(dummyDivChild).innerWidth() - $(dummyDivChild).height(100).innerWidth();
				$(dummyDiv).remove();
				return _scrollbarSize;
			},

    		displayErrorMessage : function ( msg, $form ) {

    			if ( DEBUG ) console.log('ProductFormUtilities.prototype.displayErrorMessage');

		        this.clearAddTOCartErrorMessage($form);
				
		        $('#ecom-product-actions', $form).prepend('<div class="add-to-cart-error-js error callout alert"><p>' + msg + '</p></div>');

		        $.pubsub('publish', 'WCS.PRODUCTFORM.ERRORMESSAGE', msg);
    		},

    		getProductGridProductHeights : function () {

    			if ( DEBUG ) console.log('ProductFormUtilities.prototype.getProductGridProductHeights');

				var $productGridProducts = $('.stl-product-grid-product-js');
				if($productGridProducts.length){
					$productGridProductHeights = [];
					$.each($productGridProducts, function(index, value){
						$thisHeight = $(this).outerHeight();
						$productGridProductHeights.push($thisHeight);
					});
					return $productGridProductHeights;
				}
			},

			setProductGridProductHeights : function () { 

				if ( DEBUG ) console.log('ProductFormUtilities.prototype.setProductGridProductHeights');

				var $productGridProductHeights 	= this.getProductGridProductHeights(),
					$productGridProducts 	 	= $('.stl-product-grid-product-js'),
					tallestProductHeight		= Math.max.apply(null, $productGridProductHeights),
					newHeight 					= tallestProductHeight + $('.add-to-cart-error-js').height();

					if(!$('.stl-product-grid-product-js').hasClass('error-msg-displayed')){
						$.each($productGridProducts, function(index, value){
							$(this).css('height', newHeight +'px').addClass('error-msg-displayed');
						});
					}
			},

			clearAddTOCartErrorMessage : function ($form) {

				if ( DEBUG ) console.log('ProductFormUtilities.prototype.clearAddTOCartErrorMessage');

				$('#ecom-product-actions .add-to-cart-error-js', $form).remove();
			},

			attributeName : function ($attr) {

				if ( DEBUG ) console.log('ProductFormUtilities.prototype.attributeName');

				return $attr.attr('data-attribute-id');
			},

			attributeValue : function ($attr) {

				if ( DEBUG ) console.log('ProductFormUtilities.prototype.attributeValue');

				return $attr.attr('data-color-identifier') || $attr.attr('data-attribute-value');
			},

			mobileScrollToTopViewAfterSwatchSelection : function (e) {
				
				if ( DEBUG ) console.log('ProductFormUtilities.prototype.mobileScrollToTopViewAfterSwatchSelection');
				
				var $this = $(e.target),
					closestProductForm = $this.parents('.product-form-js'),
					formIndex = $('.product-form-js').index(closestProductForm),
					headerHeight = ( $('header').hasClass('sticky') ) ? $('header').height() : 0;
				
				$this = $this.attr('data-role') ? $this.parent() : $this;

				//mobile layout scroll to product image on color selection
				if ( $this.parents('.color-swatches-js').length > 0 && (/small|medium/.test(screenSize.size()))){				
					$('html, body').animate({scrollTop:  $("div.product-img-js").eq(formIndex).offset().top - headerHeight}, "slow");
				}

			},

			unmarkSelectedAttrContainer: function($obj) {
				
				if ( DEBUG ) console.log('ProductFormUtilities.prototype.unmarkSelectedAttrContainer');
				
				$obj
					.parents('.selection-js')
						.removeClass('attribute-value-selected');
			},

			resetButtons: function($obj) {
				
				if ( DEBUG ) console.log('ProductFormUtilities.prototype.resetButtons');
				$obj
					.closest('.product-form-container')
						.find('.step-content .attr-container-js:not(.color-swatches-js) .selected')
							.removeClass('selected')
							.end()
						.end()
					.toggleClass('selected', true)
					.closest('.product-form-container')
						.find('.add-to-bag-js')
							.addClass('disabled')
							.end()
						.find('.shopcart-update-js, .find-brand-store-js, .notify-me-js, .customize-button-js')
							.hide();
			},


			resetSizeOptions: function($obj, formIndex) {

				if ( DEBUG ) console.log('resetSizeOptions');
				var theFormIndex = formIndex || $obj.closest('.product-form-js').index();
				this.unmarkSelectedAttrContainer($obj);
				this.resetButtons($obj);
				
				$.pubsub('publish', 'WCS.PRODUCTFORM.RESOLVEQUANTITY', theFormIndex);

			},

			showHideQuantityErrorMessage: function($productForm) {
				
				if ( DEBUG ) console.log('ProductFormUtilities.prototype.showHideQuantityErrorMessage');
				
				if( $("#quantity-item").length < 1 ) {
					return;				
				}
				
				if ( $("#quantity-item:visible", $productForm).length > 0 && this.isValidQuantity($productForm) ) {	
				
					$(".select-quantity-error-js", $productForm).addClass("hide");
					$("#qty-step-container", $productForm).removeClass("error");
				
				} else {
				
					$(".select-quantity-error-js", $productForm).removeClass("hide");
					$("#qty-step-container", $productForm).addClass("error");
				
				}
				
			},

			isValidQuantity: function($productForm){

				if ( DEBUG ) console.log('ProductFormUtilities.prototype.isValidQuantity');
				
				var qty = this.getQuantity($productForm);
				return (isNaN(qty) === false) && (qty > 0) && (parseInt(qty) == qty);

			},

			getQuantity: function($productForm){
			
				if ( DEBUG ) console.log('ProductFormUtilities.prototype.getQuantity');
				
				if($productForm.find('.quantity-text-js').length > 0){
					return $productForm.find('.quantity-text-js').val();
				}
				
				return $productForm.find('.quantity-js').val();

			},

			/*Generates options with attribute value*/
			generateQuantityOptions : function(quantity, upperBound){
				var options = '';
				upperBound = quantity > upperBound ? upperBound : quantity;
				if (quantity > 0){
					for (var i = 1; i <= upperBound; i++){
						options += '<option value="' + i + '">' + i + '</option>';
					}
				}
				else{
					options += '<option value="0">0</option>';
				}
				return options;
			}, 

			/**
			 * getEventType()
			 *
			 * Returns the type of event that was triggered.
			 *
			 * @param {Object} event The event object
			 * 
			 * @return {String} Returns the type of event that was triggered
			 */
			 getEventType: function(event) {
			 	return event.type;
			 }

    	};
    	
    	domReady(function(){
    		
    		if( typeof $.productFormUtil === 'undefined' ){
    			$.productFormUtil = new ProductFormUtilities().init();	
    		}

    	});

    // START close Require.JS wrapper
	}

);
// END close Require.JS wrapper